import keyMirror from "keymirror";

export default keyMirror({
  OPEN_LEGAL_DETAILS_MODAL: null,
  CLOSE_LEGAL_DETAILS_MODAL: null,
  SAVE_LEGAL_DETAILS: null,
});
